import { Grid } from '@mui/material';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
    getDryIcePurchasedPerGroup,
    getFertilizersPerGroup,
    getFuelCombustedPerGroup,
    getLpgCombustedPerGroup,
    getRefrigerantGasTopUpsPerGroup
} from '../../../../../../../actions/carbonfootprint-rework/06-dashboard/01-dashboard';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import MainCategoryButtons from '../../../shared-components/MainCategoryButtons';
import GraphMainHeader from '../../../shared-components/GraphMainHeader';
import GraphSubHeader from '../../../shared-components/GraphSubHeader';
import GraphPairForGroups from '../../../shared-components/GraphPairForGroups';
import FertilizerGraphPairForGroups from '../../../shared-components/FertilizerGraphPairForGroups';

export const ScopeOneConsumptionOverview = ({ openAccordion, changeAccordion, company, year, title, companyName, groupArray }) => {
    const dispatch = useDispatch();
    const [selectedCategory, setSelectedCategory] = useState('Stationary Combustion');

    const scopeOneCategories = ['Stationary Combustion', 'Mobile Combustion', 'Fugitive Emissions'];
    const accordionName = 'Scope One Consumption Overview'

    // stationary graphs
    const fuelCombustedDieselStationaryPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselStationaryPerGroup?.data?.graph);
    const lpgCombustedPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.lpgCombustedPerGroup?.data?.graph);

    // const fuelCombustedPetrolStationaryPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolStationaryPerGroup?.data?.graph);
    // stationary pies
    const fuelCombustedDieselStationaryPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselStationaryPerGroup?.data?.pie);
    const lpgCombustedPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.lpgCombustedPerGroup?.data?.pie);

    // const fuelCombustedPetrolStationaryPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolStationaryPerGroup?.data?.pie);

    // mobile graphs
    const fuelCombustedDieselMobilePerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselMobilePerGroup?.data?.graph);
    const fuelCombustedPetrolMobilePerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolMobilePerGroup?.data?.graph);
    // mobile pies
    const fuelCombustedDieselMobilePerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselMobilePerGroup?.data?.pie);
    const fuelCombustedPetrolMobilePerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolMobilePerGroup?.data?.pie);
    // fugitive emissions 
    const refrigerantGasTopUpsPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.refrigerantGasTopUpsPerGroup?.data?.graph);
    const refrigerantGasTopUpsPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.refrigerantGasTopUpsPerGroup?.data?.pie);

    const dryIcePurchasedPerGroupGraph = useSelector(state => state.carbonFootprintDashboardReducer.dryIcePurchasedPerGroup?.data?.graph);
    const dryIcePurchasedPerGroupPie = useSelector(state => state.carbonFootprintDashboardReducer.dryIcePurchasedPerGroup?.data?.pie);

    const fertilizersPerGroupGraph = useSelector((state) => (state.carbonFootprintDashboardReducer.fertilizersPerGroup?.data?.graph))
    const fertilizersPerGroupPie = useSelector((state) => (state.carbonFootprintDashboardReducer.fertilizersPerGroup?.data?.pie))

    useEffect(() => {
        if (openAccordion === accordionName && company && year) {
            if (selectedCategory === 'Stationary Combustion') {
                dispatch(getFuelCombustedPerGroup(company, year, 'diesel-stationary'));
                dispatch(getLpgCombustedPerGroup(company, year));
            }
            else if (selectedCategory === 'Mobile Combustion') {
                dispatch(getFuelCombustedPerGroup(company, year, 'diesel-mobile'))
                dispatch(getFuelCombustedPerGroup(company, year, 'petrol-mobile'))
            }
            else if (selectedCategory === 'Fugitive Emissions') {
                dispatch(getRefrigerantGasTopUpsPerGroup(company, year));
                dispatch(getDryIcePurchasedPerGroup(company, year));
                dispatch(getFertilizersPerGroup(company, year))
            }
        }
    }, [dispatch, openAccordion, company, year, selectedCategory])


    return (
        <DataAccordion
            title={title}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <MainCategoryButtons mainCategories={scopeOneCategories} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
            <Grid container display={'flex'}>
                {/* Overview charts */}
                {selectedCategory === 'Stationary Combustion' &&
                    <>
                        <GraphMainHeader>{selectedCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Diesel Stationary</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={fuelCombustedDieselStationaryPerGroupGraph}
                            pieChartData={fuelCombustedDieselStationaryPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Diesel Stationary Combustion'}
                            unit={'Litres'}
                        />

                        <GraphSubHeader>Liquefied Petroleum Gas (LPG)</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={lpgCombustedPerGroupGraph}
                            pieChartData={lpgCombustedPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'LPG Combustion'}
                            unit={'Kilograms'}
                        />
                    </>
                }
                {selectedCategory === 'Mobile Combustion' &&
                    <>
                        <GraphMainHeader>{selectedCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Diesel Mobile</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={fuelCombustedDieselMobilePerGroupGraph}
                            pieChartData={fuelCombustedDieselMobilePerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Diesel Mobile Combustion'}
                            unit={'Litres'}
                        />

                        <GraphSubHeader>Petrol Mobile</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={fuelCombustedPetrolMobilePerGroupGraph}
                            pieChartData={fuelCombustedPetrolMobilePerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Petrol Mobile Combustion'}
                            unit={'Litres'}
                        />
                    </>
                }
                {selectedCategory === 'Fugitive Emissions' &&
                    <>
                        <GraphMainHeader>{selectedCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Refrigerant Gas</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={refrigerantGasTopUpsPerGroupGraph}
                            pieChartData={refrigerantGasTopUpsPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Refrigerant Gas Top Ups'}
                            unit={'Litres'}
                        />

                        <GraphSubHeader>Dry Ice</GraphSubHeader>
                        <GraphPairForGroups
                            barGraphData={dryIcePurchasedPerGroupGraph}
                            pieChartData={dryIcePurchasedPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Dry Ice Purchased'}
                            unit={'Litres'}
                        />

                        <GraphSubHeader>Fertilizers Applied</GraphSubHeader>
                        <FertilizerGraphPairForGroups
                            barGraphData={fertilizersPerGroupGraph}
                            pieChartData={fertilizersPerGroupPie}
                            year={year}
                            companyName={companyName}
                            groupArray={groupArray}
                            type={'Fertilizers Applied'}
                            unit={'Kilograms'}
                        />
                    </>
                }
            </Grid>
        </DataAccordion >
    )
}
